import {
  EyeOutlined,
  FileExcelOutlined,
  FileImageOutlined,
  FilePdfOutlined,
  FileTextOutlined,
  FileWordOutlined,
  FileZipOutlined,
} from '@ant-design/icons'
import { Tooltip } from 'antd'
import moment from 'moment/moment'
import React, { useState } from 'react'
import styled from 'styled-components'
import { blue, green, purple9, redPrimary } from '../../../color'
import { DATE_TIME_FORMAT_SLASH } from '../../../constants'
import fileStore from '../../../stores/fileStore'
import FileViewPopup from '../../FileViewPopup'

const FileItemWrapper = styled.div`
  word-break: break-word;
  white-space: pre-line;
  .view-icon {
    color: ${green};
    padding: 3px 8px;
    height: 18px;
    transform: translateY(1px);
    border-radius: 4px;
    margin-left: 4px;

    &:hover {
      background-color: #f0f0f0;
    }
  }
`
const FileItem = ({ ...props }) => {
  const {
    file_id,
    file_name,
    file_type,
    deleted,
    noAction,
    file_created_at,
    isParentFile: isParentFileProp,
  } = props

  const [isVisibleFileViewPopup, setIsVisibleFileViewPopup] = useState(false)

  const isFileTruc = window.location.pathname.includes('messages')
  const isFileVIMCToTruc = window.location.pathname.includes(
    'connected-document'
  )
  const isParentFile =
    typeof isParentFileProp === 'boolean'
      ? isParentFileProp
      : window.location.pathname.includes('/company-work-schedule/parent')

  let iconFile = <FileTextOutlined />
  if (file_type === 'pdf') {
    iconFile = <FilePdfOutlined style={{ color: redPrimary }} />
  }
  if (file_type === 'doc' || file_type === 'docx') {
    iconFile = <FileWordOutlined style={{ color: blue }} />
  }
  if (
    [
      'jpg',
      'bmp',
      'dib',
      'jpe',
      'jfif',
      'gif',
      'tif',
      'tiff',
      'png',
      'heic',
    ].includes(file_type)
  ) {
    iconFile = <FileImageOutlined style={{ color: purple9 }} />
  }
  if (file_type === 'rar' || file_type === 'zip') {
    iconFile = <FileZipOutlined style={{ color: '#e67e22' }} />
  }
  if (file_type === 'xlsx' || file_type === 'xls') {
    iconFile = <FileExcelOutlined style={{ color: green }} />
  }

  return (
    <div>
      <FileItemWrapper style={{ display: 'flex' }}>
        <Tooltip title={noAction ? null : 'Tải xuống'}>
          <span
            style={{ color: blue, cursor: 'pointer' }}
            onClick={() => {
              if (noAction) return
              if (deleted) return
              if (isParentFile)
                return fileStore.handleDownloadFileParent(file_id, file_name)
              if (isFileVIMCToTruc)
                return fileStore.handleDownloadAttachmentTruc(
                  file_id,
                  file_name
                )
              if (isFileTruc)
                return fileStore.handleDownloadFileTruc(file_id, file_name)
              return fileStore.handleDownloadFile(file_id, file_name)
            }}
            className={'file-item'}>
            {!props.noIcon && iconFile} {file_name}
          </span>
        </Tooltip>
        {!noAction &&
          !props.noPreview &&
          file_type &&
          [
            'pdf',
            'doc',
            'docx',
            'xlsx',
            'xls',
            'jpg',
            'bmp',
            'dib',
            'jpe',
            'jfif',
            'gif',
            'tif',
            'tiff',
            'png',
            'heic',
          ].includes(file_type) && (
            <Tooltip title={'Xem tài liệu'}>
              <EyeOutlined
                className={'view-icon'}
                onClick={() => setIsVisibleFileViewPopup(true)}
              />
            </Tooltip>
          )}

        <FileViewPopup
          file={{
            file_name: file_name,
            file_id: file_id,
          }}
          isParentFile={isParentFile}
          isVisibleFileViewPopup={isVisibleFileViewPopup}
          handleCloseFileViewPopup={() => setIsVisibleFileViewPopup(false)}
        />
      </FileItemWrapper>
      {file_created_at ? (
        <p style={{ marginBottom: 3 }}>
          Thời gian đính kèm:
          <span style={{ marginLeft: '0.3rem' }}>
            {file_created_at
              ? moment(file_created_at).format(DATE_TIME_FORMAT_SLASH)
              : ''}
          </span>
        </p>
      ) : (
        ''
      )}
    </div>
  )
}

FileItem.propTypes = {}

export default FileItem
